var watchlistPositionDelete = {
	title: "Supprimer la position",
	caption: "Position à supprimer",
	name: "Nom",
	alertHeading: "Êtes-vous sûr de vouloir supprimer cette position?",
	alertBody: "Si oui, alors cliquez sur ok. Veuillez noter que les positions supprimées ne peuvent pas être restaurées.",
	confirmBtn: "Ok",
	cancelBtn: "Annuler"
};
var fr = {
	watchlistPositionDelete: watchlistPositionDelete
};

export { fr as default, watchlistPositionDelete };
